import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PROVIDERS = [
  { value: "anthropic", label: "Claude Sonnet 4.5" },
  { value: "gemini", label: "Gemini 3 Pro" },
  { value: "openai", label: "GPT-5.2" },
];

export default function ModelPicker({ value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-full text-xs" data-testid="model-picker">
        <SelectValue placeholder="Choose AI model" />
      </SelectTrigger>
      <SelectContent>
        {PROVIDERS.map((p) => (
          <SelectItem key={p.value} value={p.value} data-testid={`model-option-${p.value}`}>
            {p.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
